/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

export const server = "production";
export const radiusEndpointBase = "https://radius.smartwifi.ai:8080/";
export const remoteManagerEndpointBase = "https://remotemanager.smartwifi.ai:8080/";
export const urlBase = "https://dashboard.smartwifi.ai";
